// extracted by mini-css-extract-plugin
export default {"AppLink":"AppLink_AppLink__DBDj3"};